module.exports = __webpack_public_path__ + "assets/icon_download.2140317e.svg";